import React, { Fragment, useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"

import SpWallet from "./SpWallet"
import { Navbar } from "components"
import SpCheckout from "./SpCheckout"
import SpPlans from "./SpPlans"
import SpCurrentPlan from "./SpCurrentPlan"
import { getContract, getServiceOwnerWallet } from "services"
import SpTopupResultModal from "./SpTopupResultModal"
import classes from "./index.module.scss"

const SubscriptionPlans = () => {
  const history = useHistory()

  const unmount = useRef(false)

  const [page, setPage] = useState("currentPlan")
  const [extendCurrentContract, setExtendCurrentContract] = useState(false)
  const [contractDetails, setContractDetails] = useState(null)
  const [contractStats, setContractStats] = useState(null)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [serviceOwnerWallet, setServiceOwnerWallet] = useState(null)
  const [subscriptionPlans, setSubscriptionPlans] = useState(null)
  const [currentContractSubscriptionPlan, setCurrentContractSubscriptionPlan] = useState(null)

  const handleWalletTopup = async () => {
    try {
      const response =
        await getServiceOwnerWallet()

      if (unmount.current) return

      setServiceOwnerWallet({ ...response })
    } catch (err) {
      console.log(err)
    }
  }

  const handleContractUpdated = async () => {
    try {
      const latestContract = await getContract()

      const latestWallet =
        await getServiceOwnerWallet()

      if (unmount.current) return

      const { subscriptionPlan, ...contract } = latestContract

      setContractDetails({ ...contract })

      setServiceOwnerWallet({ ...latestWallet })

      setCurrentContractSubscriptionPlan({ ...subscriptionPlan[0] })
    } catch (err) {
      console.log(err)
    }
  }

  const handleGoBack = () => {
    if (page === "currentPlan") {
      return history.push("/settings")
    }

    if (page === "plans") {
      return setPage("currentPlan")
    }

    if (page === "checkout") {
      extendCurrentContract
        ? setPage("currentPlan")
        : setPage("plans")

      return
    }
  }

  const getWallet = async () => {
    if (serviceOwnerWallet !== null) return

    try {
      const response =
        await getServiceOwnerWallet()

      if (unmount.current) return

      setServiceOwnerWallet(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    getWallet()

    return () => {
      unmount.current = true
    }
  }, [])

  const getNavTitle = () => {
    if (page === "currentPlan") return "حساب کاربری"

    if (page === "plans") return "طرح ها"

    if (page === "checkout") return "سبد خرید"
  }

  const title = getNavTitle()

  return (
    <Fragment>
      <Navbar
        variant="compact"
        title={title}
        onLeftIconPress={handleGoBack}
        rightSideComponent={() =>
          serviceOwnerWallet !== null &&
          <SpWallet
            serviceOwnerWallet={serviceOwnerWallet}
            setServiceOwnerWallet={setServiceOwnerWallet}
          />
        }
      />

      <div className={classes["container"]}>
        {
          page === "currentPlan" &&
          <SpCurrentPlan
            setPage={setPage}
            setSelectedPlan={setSelectedPlan}
            contractDetails={contractDetails}
            setContractDetails={setContractDetails}
            contractStats={contractStats}
            setContractStats={setContractStats}
            setExtendCurrentContract={setExtendCurrentContract}
            currentContractSubscriptionPlan={currentContractSubscriptionPlan}
            setCurrentContractSubscriptionPlan={setCurrentContractSubscriptionPlan}
          />
        }

        {
          page === "plans" &&
          <SpPlans
            setPage={setPage}
            setSelectedPlan={setSelectedPlan}
            subscriptionPlans={subscriptionPlans}
            setSubscriptionPlans={setSubscriptionPlans}
            currentContractSubscriptionPlan={currentContractSubscriptionPlan}
          />
        }

        {
          page === "checkout" &&
          <SpCheckout
            setPage={setPage}
            selectedPlan={selectedPlan}
            subscriptionPlans={subscriptionPlans}
            serviceOwnerWallet={serviceOwnerWallet}
            setServiceOwnerWallet={setServiceOwnerWallet}
            extendCurrentContract={extendCurrentContract}
            contractDetails={contractDetails}
            setContractDetails={setContractDetails}
            setCurrentContractSubscriptionPlan={setCurrentContractSubscriptionPlan}
          />
        }
      </div>

      <SpTopupResultModal
        onWalletTopup={handleWalletTopup}
        onContractUpdated={handleContractUpdated}
      />
    </Fragment>
  )
}

export default SubscriptionPlans